document.addEventListener('DOMContentLoaded', function () {
    const tabsControls = Array.from(document.querySelectorAll('.tab-controls-container'));
    tabsControls.forEach(tabsControl => {
        const parentEl = tabsControl.closest('section');
        const tabContentEls = Array.from(parentEl?.querySelectorAll('.tab-content') ?? []);
        const thumb = tabsControl.querySelector('.tab-controls-thumb');
        const buttons = Array.from(tabsControl.querySelectorAll('.tab-controls-button'));
        let thumbTimeout;
        function changeTab(targetIndex) {
            const buttons = Array.from(tabsControl.querySelectorAll('.tab-controls-button'));
            const prevActiveEl = buttons.find(button => button.classList.contains('is-active')) ?? buttons[0];
            const currentActiveEl = buttons[targetIndex];
            clearTimeout(thumbTimeout);
            thumb.style.transitionDuration = '0s';
            thumb.style.left = `${prevActiveEl.offsetLeft}px`;
            thumb.style.width = `${prevActiveEl.offsetWidth}px`;
            thumb.style.height = `${prevActiveEl.offsetHeight}px`;
            thumb.style.top = `${prevActiveEl.offsetTop}px`;
            thumb.style.opacity = '1';
            setTimeout(() => {
                thumb.style.transitionDuration = '';
                thumb.style.left = `${currentActiveEl.offsetLeft}px`;
                thumb.style.width = `${currentActiveEl.offsetWidth}px`;
                thumb.style.height = `${currentActiveEl.offsetHeight}px`;
                thumb.style.top = `${currentActiveEl.offsetTop}px`;
            }, 10);
            thumbTimeout = window.setTimeout(() => {
                thumb.style.opacity = '0';
            }, 500);
            const prevTabContentEls = tabContentEls.filter(tabContentEl => tabContentEl.classList.contains('is-active'));
            const newTabContentEls = tabContentEls.filter(tabContentEl => targetIndex === parseInt(tabContentEl.dataset.tabId));
            // Adjust button classes
            buttons.forEach((button, index) => {
                button.ariaExpanded = index === targetIndex ? 'true' : 'false';
                if (index === targetIndex) {
                    button.classList.add('is-active');
                }
                else {
                    button.classList.remove('is-active');
                }
            });
            // Adjust content classes
            tabContentEls.forEach(tabContentEl => {
                if (targetIndex === parseInt(tabContentEl.dataset.tabId)) {
                    tabContentEl.classList.add('is-active');
                }
                else {
                    tabContentEl.classList.remove('is-active');
                }
            });
            // Send event that the tab has changed
            const eventDetails = {
                newTabId: targetIndex,
                prevTabContentEl: prevTabContentEls,
                newTabContentEl: newTabContentEls,
            };
            const event = new CustomEvent('tabChanged', { detail: eventDetails });
            tabsControl.dispatchEvent(event);
        }
        changeTab(0);
        buttons.forEach((button, index) => button.addEventListener('click', () => changeTab(index)));
    });
});
export {};
